import * as React from 'react';
import { css } from '@emotion/react';
import type { IconProps } from '@hotjar/hotsauce';
import { BaseIcon as PlayerIcon, tokens } from '@hotjar/hotsauce';

interface PlayerButtonProps {
  onClick: (e: React.SyntheticEvent<HTMLSpanElement, MouseEvent>) => void;
  icon?: IconProps['icon'];
  children: React.ReactNode;
  color?: string;
  className?: string;
  invertHoverOpacity?: boolean;
  disabled?: boolean;
  iconSize?: number;
  dataTestId?: string;
}

export const PlayerButton = ({
  onClick,
  icon,
  children,
  color,
  className,
  invertHoverOpacity,
  disabled,
  iconSize = 16,
  dataTestId = 'player-button',
}: PlayerButtonProps): JSX.Element => {
  return (
    <button
      type="button"
      onClick={onClick}
      css={css`
        font-family: ${tokens.FONT_FAMILY}, sans-serif, Arial;
        height: 30px;
        padding: 0 10px 0px 10px;
        border-radius: ${tokens.radius.m};
        border: 1px solid ${tokens.color.white};
        color: ${tokens.color.white};
        font-size: 14px;
        display: flex;
        white-space: nowrap;
        align-items: center;
        cursor: pointer;
        opacity: ${invertHoverOpacity ? 1 : 0.6};
        background: transparent;
        outline: 0;
        font-weight: 500;
        transition: opacity 0.2s ease-in-out;

        &:hover {
          opacity: ${invertHoverOpacity ? 0.7 : 0.83};
        }

        &[disabled] {
          opacity: 0.38;
        }
        &:focus {
          ${tokens.focus()};
        }
      `}
      className={className}
      disabled={disabled}
      data-testid={dataTestId}
    >
      {icon && (
        <PlayerIcon
          css={css`
            color: ${color};
            margin-right: 7px;
          `}
          icon={icon}
          pixelSize={iconSize}
        />
      )}
      {children}
    </button>
  );
};
